<template>
	<!-- 交流区 -- 板块精华 -->
	<div class="bkjhBox">
		
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox" v-if="height_scroll >=50 && tostShowBox != true" style="background: #fff !important;">
				<div class="headerQuery" style="border-bottom: 1px solid #f0f0f0;">
					<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="titleNew">{{categoryDetailInfo.title}}</p>
					<p class="header_titile">
						<img src="../../assets/img/shareBlack.png" alt="">
						<!-- <img src="../../assets/img/ellipsisBlack.png" alt=""> -->
					</p>
				</div>
			</div>
			<div class="headerBox" v-if="height_scroll <50">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">
						<img src="../../assets/img/shareBlack.png" alt="">
						<!-- <img src="../../assets/img/ellipsisBlack.png" alt=""> -->
					</p>
				</div>
			</div>
		</van-sticky>
			<div class="bgc_img" v-if="height_scroll <50">
				<img :src="$api.$BASE_URL_img + categoryDetailInfo.cover_image" alt="">
			</div>
			<div class="fixedBox">
				<div class="tximgBox">
					<img :src="$api.$BASE_URL_img + categoryDetailInfo.cover_image" alt="">
				</div>
				<div class="fixedText">
					<h4 class="fixedTitle">{{categoryDetailInfo.title}}</h4>
					<div>
						<span>版主：</span>
						<!-- 版主名称 -->
						<span class="span_one" v-if="categoryDetailInfo.moderator.length > 10">
							<van-notice-bar scrollable :text="categoryDetailInfo.moderator"></van-notice-bar>
							<!-- <i :style="{width:(categoryDetailInfo.moderator.length * 1 ) + 'em' }">{{categoryDetailInfo.moderator}}</i> -->
						</span>
						<span class="span_two" v-else>{{categoryDetailInfo.moderator}}</span>
						<span v-if="is_moderator == 0" class="btn" @click="sqbzFn">申请版主</span>
						<span v-if="is_moderator == 1" class="btn" @click="sqbzSuccenFn">版主</span>
					</div>
					<p>论坛简介：{{categoryDetailInfo.remark}}</p>
				</div>
			</div>
			<!-- 导航 -->
			<div class="yunshuNavbar_bottom">
				<div :class="navBarIndex == index ? 'active' : ''" @click="navbarFn(index)" v-for="(item,index) in navbar" :key="index">
					<span>{{item}}</span>
					<p></p>
				</div>
			</div>
			<!-- 列表 -->
			<!-- 帖子 -->
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多啦" offset="10" :immediate-check="false" @load="onLoad">
				<div class="listBox" v-if="navBarIndex == 0 ? true:false">
					<div class="listBox_chid">
						<div class="listBoxItem" v-for="(item,idx) in categoryDetailList" :key="idx" @click="jumpUrlBKM(item.id)">
							<div class="listBoxItem_top">
								<!-- <span class="jh">精华</span> -->
								<p>{{item.title}}
									<!-- <span class="dz" v-if="item.is_top == 1">置顶</span> -->
									<img src="../../assets/img/new_zd.png" alt="" v-if="item.is_top == 1">
									<img src="../../assets/img/new_jp.png" alt="" v-if="item.is_digest == 1">
									<img src="../../assets/img/new_xt.png" alt="" v-if="item.isnew == 1">
									<!-- <span class="jh" v-if="item.is_digest == 1">精华</span> -->
								</p>

							</div>
							<div class="listBoxItem_bottom">
								<div class="listBoxItem_bottom_left">
									<!-- item.anonymous == 1 为匿名 -->
									<img :src="$api.$BASE_URL_img + item.avatar" alt="" />
									<span class="penName" v-if="item.anonymous == 1">匿名</span>
									<span class="penName" v-else>{{item.nickname}}</span>
									<p class="timeData"><span v-if="item.createtime == null ? false : true">{{formatDateTime(item.createtime)}}</span></p>
								</div>
								<div class="listBoxItem_bottom_right">
									<img src="../../assets/img/ltxiaoxi.png" alt="">
									<span>{{item.comment_num}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 精华 -->
				<div class="listBox" v-if="navBarIndex == 1 ? true:false">
					<div class="listBoxItem" v-for="(item,idx) in categoryDetailList" :key="idx" @click="jumpUrlBKM(item.id)">
						<div class="listBoxItem_top">
							<!-- <p>{{item.title}}<span class="jh">精华</span></p> -->
							<p>{{item.title}}<img src="../../assets/img/new_jp.png" alt=""></p>

						</div>
						<div class="listBoxItem_bottom">
							<div class="listBoxItem_bottom_left">
								<img :src="$api.$BASE_URL_img + item.avatar" alt="" />
								<span class="penName" v-if="item.anonymous == 1">匿名</span>
								<span class="penName" v-else>{{item.nickname}}</span>
								<p class="timeData"><span v-if="item.createtime == null ? false : true">{{formatDateTime(item.createtime)}}</span></p>
							</div>
							<div class="listBoxItem_bottom_right">
								<img src="../../assets/img/ltxiaoxi.png" alt="">
								<span>{{item.comment_num}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-list>
			</van-pull-refresh>
		<!-- 弹窗 -->
		<div class='luntan_tost_box' v-show="tostShowBox">
			<div class="header_img">
				<img src="../../assets/img/luntanImg.png" alt="">
			</div>
			<div class='cat_img'>
				<img src="../../assets/img/cat.png" alt="" />
			</div>
			<div class="luntan_tostValBox">
				<div class="biaoti_tit">
					<span>标题</span>
					<input type="text" placeholder="默认板块名称" :value="categoryDetailInfo.title" />
				</div>
				<div class="sqlyBox">
					<p>申请理由</p>
					<div class="right_txt">
						<textarea name="" id="" cols="30" rows="10" maxlength="1000" @input="descInput" v-model="desc"></textarea>
						<span class="xianzhi">{{remnant}}/1000</span>
					</div>
				</div>
				<div class="submit_btn">
					<img src="../../assets/img/luntan_cao.png" alt="">
					<button @click="submit_btn">提交</button>
				</div>
			</div>
		</div>
		<div class="mask" v-show="tostShowBox" @click="maskFn"></div>
		<!-- 添加 -->
		<div class="add" @click="addFn">
			<img src="../../assets/img/add.png" alt="">
		</div>
		
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				navBarIndex: 0,
				navbar: ["帖子", "精华"],
				desc: '', //文本域内容  申请版主 理由
				remnant: 0, //开始字数
				tostShowBox: false,
				newestListId: '',
				categoryDetailInfo: {},
				categoryDetailList: [],
				is_moderator: '',
				height_scroll: 0,
				anonymous_name: ['匿名', '匿名', '匿名', '匿名', '匿名', '匿名'],
				anonymous_url: ['/uploads/20200331/b6aa12415d510ad363ef17ac77aa0e2c.jpg',
					'/uploads/20200331/62335b1ebab479e0a06b4cbd83b6681a.jpg',
					'/uploads/20200331/027821507b7353583a744b71162e67df.jpg'
				],
				page: 1,
				page_total: 1,
				limit: 10,
				isLoading: false,
				loading: false,
				finished: false,
				refreshing: false,
			}
		},
		created() {
			this.newestListId = this.$route.query.newestListId;
			this.category_detail();
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// this.$router.go(0)
					this.page = 1;
					this.category_detail();
					this.isLoading = false;
				}, 1000);
			},
			back() {
				this.$router.push('/forum')
			},
			sqbzFn() { // 申请版主弹窗
				this.tostShowBox = !this.tostShowBox
			},
			sqbzSuccenFn() {
				Toast('您已经是版主了，无需申请')
			},
			maskFn() {
				this.tostShowBox = false;
			},
			//帖子详情
			jumpUrlBKM(id) {
				this.$router.push({
					path: '/tieziInfo',
					query: {
						tzxqInfoId: id
					}
				})
			},
			submit_btn() { //弹窗 提交按钮
				if (this.desc != '') {
					this.$axios.post(this.$api.apply_forum_moderator, {
						category_id: this.newestListId, //版块id
						reason: this.desc, //申请理由
					}).then(res => {
						Toast(res.data.msg)
						this.tostShowBox = !this.tostShowBox;
					})
				} else {
					Toast('理由不能为空')
				}

			},
			// 文本域字数限制
			descInput() {
				let txtVal = this.desc.length;
				this.remnant = 0 + txtVal;
			},
			navbarFn(data) {
				this.navBarIndex = data;
				this.categoryDetailList = [];
				this.page = 1;
				if (this.navBarIndex == 0) {
					this.navBarIndex = 0;
					this.category_detail();
				} else if (this.navBarIndex == 1) {
					this.navBarIndex = 1;
					this.category_detail();
				}
			},
			// 论坛版块详情
			category_detail() {
				this.$axios.post(this.$api.category_detail, {
					category_id: this.newestListId,
					is_digest: this.navBarIndex,
					limit: this.limit,
					page: this.page
				}).then(res => {
					this.categoryDetailInfo = res.data.data.info;
					this.is_moderator = res.data.data.is_moderator;
					// this.page_total = Math.ceil(res.data.data.count/this.limit);

					var list = res.data.data.list;
					for (var i = 0; i < list.length; i++) {
						if (list[i].anonymous == 1) {
							list[i].nickname = this.anonymous_name[Math.floor(Math.random() * 6)]
							list[i].avatar = this.anonymous_url[Math.floor(Math.random() * 3)]
						}
					}
					// if(this.categoryDetailList.length){ //有旧数据（数据拼接）
					// 	// this.categoryDetailList = this.categoryDetailList.concat(list);
					// }else{
					this.categoryDetailList = list;
					// }
					if (res.data.data.count === this.categoryDetailList.length) {
						this.finished = true
					} else {
						this.finished = false
					}

					this.refreshing = false;
					this.loading = false;
					this.page = 2;
				})
			},
			onLoad() {
				this.$axios.post(this.$api.category_detail, {
					category_id: this.newestListId,
					is_digest: this.navBarIndex,
					limit: this.limit,
					page: this.page
				}).then(res => {
					let datas = res.data.data.list;
					this.categoryDetailList = this.categoryDetailList.concat(datas)
					if (this.categoryDetailList.length < res.data.data.count) {
						this.page++;
						this.loading = false
					} else {
						this.finished = true
						this.loading = true
					}
				})
			},
			addFn() {
				if (!localStorage.getItem('userInfoData')) {
					this.$toast('您还没有登录，不能发帖哟!');
				} else {
					this.$router.push({
						path: '/fbxt',
						query: {
							categoryDetailId: this.newestListId,
							categoryDetailInfo: this.categoryDetailInfo.title
						}
					})
				}

			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			handleScroll() {
				var _t = this;
				this.height_scroll = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// if(_t.height_scroll + windowHeight >= scrollHeight) {
				// 	if(_t.page > _t.page_total){
				// 		_t.$toast('没有更多数据了！');
				// 	}else{
				// 		_t.page ++;
				// 		_t.category_detail();
				// 	}
				// }
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll) //  离开页面清除（移除）滚轮滚动事件
		}
	}
</script>

<style lang="less" scoped>
	.mask {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, .4);
	}

	.bkjhBox {
		height: 100vh;
		background-color: #fff;
		color: #000;

		// 头部
		.headerBox {
			height: 160px;
			background-color: transparent;
			display: flex;

			.headerQuery {
				margin-top: 50px;
				padding: 0 20px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
				z-index: 100;

				.backImg {
					position: absolute;
					bottom: 10px;
					left: 0;
					width: 100%;
				}

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
						z-index: 99;
					}
				}

				.titleNew {
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					word-break: break-word;
					line-clamp: 1;
					-webkit-line-clamp: 1;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					text-align: center;
					position: absolute;
					top: 0;
					left: 0;
					font-size: 34px;
				}

				.header_titile {
					flex: 1;
					text-align: right;

					img {
						width: 40px;
						vertical-align: middle;
					}
				}
			}

		}

		.bgc_img {
			img {
				width: 100%;
				height: 300px;
				position: fixed;
				top: 0;
				left: 0;
				-webkit-filter: blur(15px);
				-moz-filter: blur(15px);
				-o-filter: blur(15px);
				-ms-filter: blur(15px);
				filter: blur(15px);
			}
		}

		.fixedBox {
			background-color: #fff;
			position: relative;
			margin-top: 70px;
			padding: 0 20px;
			padding-bottom: 20px;

			.tximgBox {
				img {
					width: 160px;
					height: 160px;
					position: absolute;
					top: -70px;
					left: 20px;
					box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
				}
			}

			.fixedText {
				margin-left: 180px;
				position: relative;

				h4 {
					position: absolute;
					top: -60px;
					left: 0;
					font-size: 34px;
					/*px*/
					font-weight: bold;
				}

				div {
					line-height: 60px;
					color: rgba(0, 0, 0, 0.6);
					font-size: 26px;
					display: flex;
					align-items: center;

					i {
						font-style: normal;
						display: inline-block;
					}

					.btn {
						border-radius: 20px;
						line-height: 40px;
						background-color: #ffdd2b;
						color: #fff;
						font-weight: 400;
						padding: 5px 15px;
						margin-left: 20px;
					}

					.span_one {
						display: inline-block;
						width: 240px;

						// overflow-x: scroll;
						// height:45px;
						// line-height: 45px;
						.van-swipe .van-swipe__track--vertical .van-swipe-item {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}

						.van-notice-bar {
							background: rgba(0, 0, 0, 0);
							color: rgba(0, 0, 0, 0.6);
							height: 45px;
							padding: 0;
						}
					}
				}

				p {
					color: rgba(0, 0, 0, 0.4);
					font-size: 24px;
					height: 40px;
					line-height: 40px;
					overflow: hidden;
				}

			}
		}

		//导航
		.yunshuNavbar_bottom {
			padding: 0 20px;
			padding-bottom: 20px;
			background-color: #fff;

			div {
				display: inline-block;
				text-align: center;
				font-size: 34px;
				/*px*/
				width: 100px;
				position: relative;

				span {
					width: 100px;
					line-height: 60px;
					display: inline-block;
					color: #3d3d3d;
				}

				p {
					width: 60px;
					height: 4px;
					position: absolute;
					bottom: 0px;
					left: 50%;
					transform: translateX(-50%);
					background-color: transparent;
					border-radius: 4px;
				}

			}

			div.active {
				p {
					background-color: #f4ce72;
				}

				span {
					color: #000000;
					font-weight: 700;
					font-weight: bold;
				}
			}


		}

		//列表
		.listBox {
			padding: 0 16px 80px;
			background-color: #fff;
			// height: calc(100vh - 470px);
			// overflow: hidden;

			.listBox_chid {
				// height: calc(100vh - 470px);
				// overflow-y: scroll;
			}

			.listBoxItem {
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.listBoxItem_top {
					position: relative;
					padding-top: 20px;

					p {
						font-size: 34px;
						/*px*/
						color: #000;
						line-height: 60px;

						/*px*/
						span {
							line-height: 0px;
							/*px*/
							padding: 20px 25px;
							display: inline-block;
							border-radius: 8px;
							font-size: 24px;
							/*px*/
						}

						span:last-child {
							margin-left: 20px;
						}

						span.dz {
							color: #ff9470;
							border: 1px solid #ff9470;
							/*no*/
						}

						span.jh {
							color: #fa7298;
							border: 1px solid #fa7298;
							/*no*/
						}
					}

					img {
						width: 35px;
						height: 35px;
						margin-left: 20px;
					}

				}

				.listBoxItem_bottom {
					display: flex;
					height: 35px;
					/*no*/

					.listBoxItem_bottom_left {
						flex: 1;
						color: #a3a3a3;
						line-height: 30px;

						/*no*/
						img {
							width: 40px;
							height: 40px;
							vertical-align: middle;
							border-radius: 50%;
							box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
							display: inline-block;
						}

						.timeData {
							display: inline-block;
							font-size: 24px;

							/*px*/
							.time {
								padding-left: 10px;
							}
						}

						.penName {
							padding: 0 20px;
							font-size: 24px;
							/*px*/
						}
					}

					.listBoxItem_bottom_right {
						width: 100px;
						text-align: right;
						position: relative;

						img {
							width: 35px;
							padding-right: 10px;
							position: absolute;
							right: 20px;
							top: 50%;
							transform: translateY(-50%);
						}

						span {
							display: inline-block;
							line-height: 35px;

							/*no*/
						}
					}
				}
			}
		}

		//弹窗
		.luntan_tost_box {
			z-index: 100;
			position: fixed;
			bottom: 0;
			left: 0;
			height: 700px;
			width: 100vw;
			overflow: hidden;

			.header_img {
				position: absolute;
				top: 2px;
				left: 0;

				img {
					width: 100vw;
				}
			}

			.cat_img {
				position: absolute;
				bottom: 20px;
				left: 0;

				img {
					width: 100vw;
				}
			}

			.luntan_tostValBox {
				padding: 0 16px;
				margin-top: 120px;
				background-color: #fff;

				.biaoti_tit {

					display: flex;
					line-height: 80px;
					border-bottom: 1px solid #f0f0f0;

					/*no*/
					input {
						flex: 1;
					}

					span {
						margin-right: 20px;
						font-size: 30px;
						/*px*/
					}
				}

				.sqlyBox {
					p {
						line-height: 80px;
						font-size: 30px;
						/*px*/
					}

					.right_txt {
						margin-right: 0;
						height: 200px;
						flex: 1;
						font-size: 30px;
						/*px*/
						color: #a3a3a3;
						border-bottom: 1px solid #f0f0f0;
						/*no*/
						position: relative;

						// background: url(../../assets/img/cat.png) no-repeat center;
						// background-size: 100%;
						// background-position: 50% -10%;
						textarea {
							width: calc(100vw - 32px);
							text-align: left;
							height: 200px;
							border: 0;
							background-color: transparent;
						}

						textarea::placeholder {
							font-size: 30px;
							/*px*/
						}

						.xianzhi {
							background-color: #fff;
							position: absolute;
							bottom: 0;
							right: 0;
							color: #999999;
							line-height: 60px;
							font-size: 32px;
							/*px*/
						}
					}
				}

				.submit_btn {
					position: relative;
					text-align: center;
					margin-top: 100px;
					padding-bottom: 50px;

					img {
						position: absolute;
						top: -42%;
						left: 15%;
						width: 60px;
					}

					button {
						width: 90%;
						border: 0;
						border-radius: 10px;
						line-height: 80px;
						font-size: 32px;
						/*px*/
						background-color: #ffdd2b;
						color: #fff;
					}
				}
			}
		}

		//添加
		.add {
			img {
				position: fixed;
				right: 20px;
				bottom: 50px;
				width: 140px;
			}
		}
	}
</style>
